import React from 'react';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { Popper } from '@material-ui/core';

import CoreButton from 'components/Buttons/CoreButton';

export interface SahamDropDownProps {
  label: string;
  dropDownRootClassName?: string;
  children?: React.ReactNode;
  setDropDown: Function;
  dropDown: null | HTMLElement;
  iconclass?: string;
}

export const SahamDropDown: React.FC<SahamDropDownProps> = (
  props,
): JSX.Element => {
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    props.setDropDown(props.dropDown ? null : event.currentTarget);
  };

  return (
    <div className={props.dropDownRootClassName}>
      <CoreButton
        className="drop-down-button"
        title={props.label}
        onClick={handleClick}
        righticon={<ArrowDropDownIcon className={props.iconclass} />}
      />
      <Popper
        open={Boolean(props.dropDown)}
        anchorEl={props.dropDown}
        placement="bottom"
        transition
        disablePortal
        className="popper"
      >
        {props.children}
      </Popper>
    </div>
  );
};

export default SahamDropDown;
